import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faPause, faPencil } from '@fortawesome/free-solid-svg-icons';

import './GameIcon.css';

const initials = (name) => String(name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(w => w.charAt(0))
    .join('')
    .toUpperCase() || '?';

/**
 * A game's icon: its `gameIconUrl` when set, its initials otherwise. A DRAFT game carries an
 * overlay badge so an unfinished game reads differently from a live one in any list - and so does a
 * frozen one: SUSPENDED (pause, amber) and SUNSET (ban, red), whose pages are closed until reactivated.
 */
const GameIcon = ({ iconUrl, name, state, size = 18 }) => {
    const [broken, setBroken] = useState(false);
    const src = String(iconUrl || '').trim();
    // Give each new URL a fresh chance: a prior load failure (e.g. a store-CDN 429, or
    // a just-replaced icon) must not stick and keep showing initials for the next one.
    useEffect(() => { setBroken(false); }, [src]);
    const showImg = !!src && !broken;

    return (
        <span className="game-icon" style={{ width: size, height: size }} title={name}>
            {showImg ? (
                <img src={src} alt="" className="game-icon-img" onError={() => setBroken(true)} />
            ) : (
                <span className="game-icon-initials" style={{ fontSize: Math.max(8, Math.round(size * 0.42)) }}>
                    {initials(name)}
                </span>
            )}
            {state === 'DRAFT' && (
                <span className="game-icon-draft" aria-label="Draft">
                    <FontAwesomeIcon icon={faPencil} />
                </span>
            )}
            {state === 'SUSPENDED' && (
                <span className="game-icon-draft game-icon-suspended" aria-label="Suspended" title={`${name} is suspended`}>
                    <FontAwesomeIcon icon={faPause} />
                </span>
            )}
            {state === 'SUNSET' && (
                <span className="game-icon-draft game-icon-sunset" aria-label="Sunset" title={`${name} is sunset`}>
                    <FontAwesomeIcon icon={faBan} />
                </span>
            )}
        </span>
    );
};

export default GameIcon;
